module.exports = __webpack_public_path__ + "img/S3F6.cf5aac46.jpg";